module.exports = __webpack_public_path__ + "site/img/263.af829535.jpg";